// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"d3e7acb7","769":"470de70a"}[chunkId] + ".chunk.css";
};